import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import {checkCookie} from 'ubs-framework/v2/common/function';
import AppHeader from '../../app-account/common/components/app-header'
import * as Icon from 'ubs-icons'
import { COLOR } from '../../common/constant'
import { isInApp } from 'ubs-framework/v2/common/function'
import { sendData } from '../../store/actions'
import useSocket from '../../app-account/common/useSocket'
import { useDispatch } from 'react-redux'
import {withRouter} from "../../common/hocs/routing-hoc";

function Layout({ children, module, projectRoutes }) {
    const { orgId } = useParams()
    const history = useHistory()
    const dispatch = useDispatch()
    const [toggleLoginBtn, setToggleLoginBtn] = useState(false)
    const [details, setDetails] = useState(null)

    const { on, off, refresh } = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'getCompanyDetails':
                    setDetails(res.data)
                    break
                default:
                    return true
            }
        }
    })
    useEffect(() => {
        if (!checkCookie('ubs_token')) setToggleLoginBtn(true)
        else setToggleLoginBtn(false)
        if(orgId) sendData(dispatch, 'getCompanyDetails', { orgId })
        else setDetails(null)

        refresh()
        return () => off()
    }, [])

    return (
        <section className="u_account u_h-full">
            {/*<UCustomScrollBar>*/}
            <div className="u_account-inner u_h-full">
                <div className="u_account-inner__image">
                    <div className="u_logo-image">
                        <img className="u_logo-top" src={details?.companyLogo?.length ? details?.companyLogo : '/../images/images/u-text-logo.svg'} alt="Logo"/>
                        <AppHeader align="true" header={`Welcome to ${details?.company ? details?.company : 'Superworks'}`}
                                   title={details ? 'We are work obsessed people' : 'Connecting People. Optimizing Process. Enhancing Perfomance.'}/>
                    </div>
                    <div className="u_process-image u_align-center u_flex u_content-center">
                        <div className="u_product">
                            <div className="u_product-hrms">
                                <Icon.HRMS size={20}/>
                            </div>
                            <div className="u_product-pms">
                                <Icon.PMS size={20}/>
                            </div>
                            <div className="u_product-chat">
                                <Icon.UbsChat size={20}/>
                            </div>
                            <div className="u_product-payroll">
                                <Icon.PayrollLogo size={20}/>
                            </div>
                            <div className="u_logo-center">
                                <div className="u_logo-inner">
                                    <img src="/../images/images/logo.png" alt="Logo"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="u_left-text">
                        <AppHeader align="true" header="Core Values"/>
                        <ul className="u_left-text-inner">
                            <li><span className="u_flex"><Icon.DoubleTick size={18} fill={COLOR.u_orange}/></span>Working
                                Everyday Towards Perfection
                            </li>
                            <li><span className="u_flex"><Icon.DoubleTick size={18} fill={COLOR.u_orange}/></span>Inspiring
                                Teams To Build The Best
                            </li>
                            <li><span className="u_flex"><Icon.DoubleTick size={18} fill={COLOR.u_orange}/></span>Grow
                                Consistently Every Day
                            </li>
                            <li><span className="u_flex"><Icon.DoubleTick size={18} fill={COLOR.u_orange}/></span>Creating
                                Value Adding Services
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="u_account-inner__input u_align-center">
                    <div className="u_login-input__section">
                        {children}
                        {(module === 'register') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Already have an account? <span className="u_cp" onClick={e => history.push('/login')}>Sign In</span></p>}

                        {(module === 'login') && toggleLoginBtn && !isInApp() &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an account? <span className="u_cp" onClick={e => history.push('/register')}>Sign Up</span></p>}

                        {(module === 'forgot') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Remember Password ? <span className="u_cp" onClick={e => history.push('/login')}>Sign In</span></p>}

                        {(module === 'on-boarding-forgot') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Remember Password ? <span className="u_cp" onClick={e => history.push(projectRoutes?.login || `/${orgId}/login`)}>Sign In</span></p>}

                        {(module === 'on-boarding-register') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Already have an account? <span className="u_cp" onClick={e => history.push(projectRoutes?.login || `/${orgId}/login`)}>Sign In</span>
                        </p>}

                        {(module === 'on-boarding-login') && toggleLoginBtn && !isInApp() &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an account? <span className="u_cp" onClick={e => history.push(projectRoutes?.register || `/${orgId}/register`)}>Sign Up</span>
                        </p>}

                        {(module === 'multiFactorAuthenticate') && toggleLoginBtn &&
                        <p className="u_send-code u_t-center u_mt-20">Don’t have an Google Authenticator code? <span className="u_cp" onClick={e => history.push(projectRoutes?.recoveryCode || `/${orgId}/recovery-code`)}>Add Recovery Code</span>
                        </p>}
                    </div>
                    <div className="u_copyright u_flex u_content-center u_align-center">
                        <p className="u_t-center">Copyright © 2020-{new Date().getFullYear()} Superworks Company. All rights reserved.</p>
                    </div>
                </div>

            </div>
        </section>
    )
}


Layout.defaultProps = {
    module: 'both',
}

export default withRouter(Layout)
